<ngx-spinner bdColor="#000000aa" size="medium" color="#64b2cd" type="line-scale-pulse-out-rapid" [fullScreen]="true">
    <h6>Processando...</h6>
</ngx-spinner>

<div class="section">
    <div class="config-area">
        <div class="header">
            <div class="config-title">
                <div class="title-container">
                    <h3 class="title m-0">
                        <span class="label">Instâncias de Fluxo executadas</span>
                    </h3>
                </div>
            </div>
        </div>

        <hr />

        <h5 class="subtitle mb-3">Adicionar critérios para filtragem</h5>

        <!-- Filtro -->
        <div class="config-inputs">
            <div class="predefined-filter-search ml-4">
                <!-- Data de Encerramento -->
                <div class="predefined-filter-section flex-column align-items-start mt-3" [class.closed]="!$isShowingFinishDateSection()">
                    <div class="title text-highlight info-font" (click)="toggleFinishDateSection()" (keyDown)="toggleFinishDateSection()">
                        <i class="toggle-section fas fa-chevron-circle-right mr-1" [class.on]="$isShowingFinishDateSection()"></i>
                        <span>Data de Encerramento</span>
                        <i class="toggle-section fas fa-chevron-circle-left ml-1" [class.on]="$isShowingFinishDateSection()"></i>
                    </div>

                    <!-- Intervalo predeterminado -->
                    <div class="subtitle info-font my-2" [class.invisible]="!$isShowingFinishDateSection()">• Intervalo predeterminado:</div>

                    <div class="section-content" [class.invisible]="!$isShowingFinishDateSection()">
                        <div class="predefined-datetime button-text ml-4">
                            <button type="button" class="btn btn-outline-primary py-0 px-2"
                                    matTooltip="Adicionar critério"
                                    (click)="addCustomFinishDateFilterCriteria(CustomDateTimeCriteriaType.Today)"
                                    (keyDown)="addCustomFinishDateFilterCriteria(CustomDateTimeCriteriaType.Today)"
                            >
                                <i class="fas fa-clock mr-1"></i>
                                <span>Hoje</span>
                            </button>

                            <button type="button" class="btn btn-outline-primary py-0 px-2 ml-2"
                                    matTooltip="Adicionar critério"
                                    (click)="addCustomFinishDateFilterCriteria(CustomDateTimeCriteriaType.Last24)"
                                    (keyDown)="addCustomFinishDateFilterCriteria(CustomDateTimeCriteriaType.Last24)"
                            >
                                <i class="fas fa-clock mr-1"></i>
                                <span>Últimas 24h</span>
                            </button>

                            <button type="button" class="btn btn-outline-primary py-0 px-2 ml-2"
                                    matTooltip="Adicionar critério"
                                    (click)="addCustomFinishDateFilterCriteria(CustomDateTimeCriteriaType.Last48)"
                                    (keyDown)="addCustomFinishDateFilterCriteria(CustomDateTimeCriteriaType.Last48)"
                            >
                                <i class="fas fa-clock mr-1"></i>
                                <span>Últimas 48h</span>
                            </button>

                            <button type="button" class="btn btn-outline-primary py-0 px-2 ml-2"
                                    matTooltip="Adicionar critério"
                                    (click)="addCustomFinishDateFilterCriteria(CustomDateTimeCriteriaType.Last72)"
                                    (keyDown)="addCustomFinishDateFilterCriteria(CustomDateTimeCriteriaType.Last72)"
                            >
                                <i class="fas fa-clock mr-1"></i>
                                <span>Últimas 72h</span>
                            </button>

                            <button type="button" class="btn btn-outline-primary py-0 px-2 ml-2"
                                    matTooltip="Adicionar critério"
                                    (click)="addCustomFinishDateFilterCriteria(CustomDateTimeCriteriaType.LastWeek)"
                                    (keyDown)="addCustomFinishDateFilterCriteria(CustomDateTimeCriteriaType.LastWeek)"
                            >
                                <i class="fas fa-clock mr-1"></i>
                                <span>Última semana</span>
                            </button>

                            <button type="button" class="btn btn-outline-primary py-0 px-2 ml-2"
                                    matTooltip="Adicionar critério"
                                    (click)="addCustomFinishDateFilterCriteria(CustomDateTimeCriteriaType.LastFortnight)"
                                    (keyDown)="addCustomFinishDateFilterCriteria(CustomDateTimeCriteriaType.LastFortnight)"
                            >
                                <i class="fas fa-clock mr-1"></i>
                                <span>Última quinzena</span>
                            </button>

                            <button type="button" class="btn btn-outline-primary py-0 px-2 ml-2"
                                    matTooltip="Adicionar critério"
                                    (click)="addCustomFinishDateFilterCriteria(CustomDateTimeCriteriaType.LastMonth)"
                                    (keyDown)="addCustomFinishDateFilterCriteria(CustomDateTimeCriteriaType.LastMonth)"
                            >
                                <i class="fas fa-clock mr-1"></i>
                                <span>Último mês</span>
                            </button>

                            <button type="button" class="btn btn-outline-primary py-0 px-2 ml-2"
                                    matTooltip="Adicionar critério"
                                    (click)="addCustomFinishDateFilterCriteria(CustomDateTimeCriteriaType.LastYear)"
                                    (keyDown)="addCustomFinishDateFilterCriteria(CustomDateTimeCriteriaType.LastYear)"
                            >
                                <i class="fas fa-clock mr-1"></i>
                                <span>Último ano</span>
                            </button>
                        </div>
                    </div>

                    <!-- Intervalo customizado -->
                    <div class="subtitle info-font mt-3" [class.invisible]="!$isShowingFinishDateSection()">• Intervalo customizado:</div>

                    <div class="section-content" [class.invisible]="!$isShowingFinishDateSection()">
                        <div class="custom-datetime ml-4">
                            <div class="keep-left">
                                <div class="form-group mb-0">
                                    <label for="selectedFromDateTime">De</label>
                                    <div class="d-flex">
                                        <datetime-picker [value]="$selectedFromDateTime()" (valueChange)="$selectedFromDateTime.set($event)"></datetime-picker>
                                    </div>
                                </div>

                                <div class="form-group mb-0 ml-3">
                                    <label for="selectedUntilDateTime">Até</label>
                                    <div class="d-flex">
                                        <datetime-picker [value]="$selectedUntilDateTime()" (valueChange)="$selectedUntilDateTime.set($event)"></datetime-picker>
                                    </div>
                                </div>
                            </div>

                            <button type="button" class="btn btn-outline-primary py-0 px-2 ml-3"
                                    matTooltip="Adicionar critério"
                                    [disabled]="$selectedFromDateTime() == null && $selectedUntilDateTime() == null"
                                    (click)="addPredefinedFinishDateFilterCriteria()"
                                    (keyDown)="addPredefinedFinishDateFilterCriteria()"
                            >
                                <i class="fas fa-plus-circle mr-1"></i>
                                <span>Adicionar critério</span>
                            </button>

                            <button type="button" class="btn btn-outline-danger py-0 px-2 ml-1"
                                    matTooltip="Limpar valores"
                                    [disabled]="$selectedFromDateTime() == null && $selectedUntilDateTime() == null"
                                    (click)="clearFinishDateFilterCriteria()"
                                    (keyDown)="clearFinishDateFilterCriteria()"
                            >
                                <i class="fas fa-times-circle mr-1"></i>
                                <span>Limpar</span>
                            </button>
                        </div>
                    </div>
                </div>

                <div class="chip-container mt-3">
                    @if (getSearchTokensFinishDate().length == 0) {
                        <div class="chip default-filter">
                            <span>Sem Filtros</span>
                        </div>
                    } @else {
                        @for (searchToken of getSearchTokensFinishDate(); track searchToken) {
                            <div class="chip">
                                <span>{{searchToken.text}}</span>
                                <i class="icon fas fa-times-circle ml-1"
                                   matTooltip="Remover filtro"
                                   (click)="removeFilter(searchToken)"
                                   (keyDown)="removeFilter(searchToken)"
                                ></i>
                            </div>
                        }
                    }
                </div>
            </div>
        </div>

        <!-- Ações -->
        <div class="actions">
            <!-- Mostrar estatísticas -->
            <button type="button" class="btn btn-outline-primary"
                    [disabled]="shouldDisableSearch()"
                    (click)="getResults()"
                    (keyDown)="getResults()"
            >
                <i class="fas fa-chart-bar mr-2"></i>
                <span>Mostrar estatísticas</span>
            </button>

            <!-- Exportar CSV -->
            <button type="button" class="btn btn-outline-primary"
                    [disabled]="shouldDisableSearch()"
                    (click)="exportCsv()"
                    (keyDown)="exportCsv()"
            >
                <i class="fas fa-file-csv mr-2"></i>
                <span>Exportar dados em formato CSV</span>
            </button>
        </div>
    </div>

    <!-- Estatísticas -->
    @if ($results() != null && $showResults()) {
        <div class="results-area">
            <hr />

            <div class="results-area-section counters mt-3">
                <dashboard-item class="w-20"
                                [_counter]="$results().countFinishedFlowInstances"
                                [_counterLabel]="FinishedFlowInstancesDescription.get('countFinishedFlowInstances')"
                ></dashboard-item>
                <dashboard-item class="w-20"
                                [_counter]="$results().countEFlow"
                                [_counterLabel]="FinishedFlowInstancesDescription.get('countEFlow')"
                ></dashboard-item>
                <dashboard-item class="w-20"
                                [_counter]="$results().countEDocs"
                                [_counterLabel]="FinishedFlowInstancesDescription.get('countEDocs')"
                ></dashboard-item>
                <dashboard-item class="w-20"
                                [_counter]="$results().countPortalES"
                                [_counterLabel]="FinishedFlowInstancesDescription.get('countPortalES')"
                ></dashboard-item>
                <dashboard-item class="w-20"
                                [_counter]="$results().countConecta"
                                [_counterLabel]="FinishedFlowInstancesDescription.get('countConecta')"
                ></dashboard-item>
            </div>

            <div class="results-area-section counters mt-2">
                <dashboard-item class="w-25"
                                [_counter]="$results().countTargetCitizen"
                                [_counterLabel]="FinishedFlowInstancesDescription.get('countTargetCitizen')"
                ></dashboard-item>
                <dashboard-item class="w-25"
                                [_counter]="$results().countTargetPatriarch"
                                [_counterLabel]="FinishedFlowInstancesDescription.get('countTargetPatriarch')"
                ></dashboard-item>
                <dashboard-item class="w-25"
                                [_counter]="$results().countTargetOrganization"
                                [_counterLabel]="FinishedFlowInstancesDescription.get('countTargetOrganization')"
                ></dashboard-item>
                <dashboard-item class="w-25"
                                [_counter]="$results().countTargetUnit"
                                [_counterLabel]="FinishedFlowInstancesDescription.get('countTargetUnit')"
                ></dashboard-item>
            </div>

            <div class="results-area-section charts mt-5">
                <div class="chart-container pb-2">
                    <label class="info-font mt-3" for="chart">Fluxos por Patriarca</label>
                    <div class="chart-wrapper">
                        <ngx-charts-bar-vertical xAxisLabel="Patriarcas"
                                                 yAxisLabel="Fluxos"
                                                 legendTitle=""
                                                 [results]="$topPatriarchs()"
                                                 [xAxis]="true"
                                                 [showXAxisLabel]="false"
                                                 [yAxis]="true"
                                                 [showYAxisLabel]="true"
                                                 [legend]="false"
                                                 [gradient]="true"
                                                 [showDataLabel]="true"
                        ></ngx-charts-bar-vertical>
                    </div>
                </div>

                <div class="chart-container pb-2">
                    <label class="info-font mt-3" for="chart">Fluxos por Patriarca (sem GOVES)</label>
                    <div class="chart-wrapper">
                        <ngx-charts-bar-vertical xAxisLabel="Patriarcas"
                                                 yAxisLabel="Fluxos"
                                                 legendTitle=""
                                                 [results]="$topPatriarchsSemGoves()"
                                                 [xAxis]="true"
                                                 [showXAxisLabel]="false"
                                                 [yAxis]="true"
                                                 [showYAxisLabel]="true"
                                                 [legend]="false"
                                                 [gradient]="true"
                                                 [showDataLabel]="true"
                        ></ngx-charts-bar-vertical>
                    </div>
                </div>
            </div>

            <div class="results-area-section charts mt-5">
                <div class="chart-container pb-2">
                    <label class="info-font mt-3" for="chart">Fluxos por Órgão</label>
                    <div class="chart-wrapper">
                        <ngx-charts-bar-vertical xAxisLabel="Órgãos"
                                                 yAxisLabel="Fluxos"
                                                 legendTitle=""
                                                 [results]="$topOrganizations()"
                                                 [xAxis]="true"
                                                 [showXAxisLabel]="false"
                                                 [yAxis]="true"
                                                 [showYAxisLabel]="true"
                                                 [legend]="false"
                                                 [gradient]="true"
                                                 [showDataLabel]="true"
                        ></ngx-charts-bar-vertical>
                    </div>
                </div>

                <div class="chart-container pb-2">
                    <label class="info-font mt-3" for="chart">Fluxos por Órgão (sem GOVES)</label>
                    <div class="chart-wrapper">
                        <ngx-charts-bar-vertical xAxisLabel="Órgãos"
                                                 yAxisLabel="Fluxos"
                                                 legendTitle=""
                                                 [results]="$topOrganizationsSemGoves()"
                                                 [xAxis]="true"
                                                 [showXAxisLabel]="false"
                                                 [yAxis]="true"
                                                 [showYAxisLabel]="true"
                                                 [legend]="false"
                                                 [gradient]="true"
                                                 [showDataLabel]="true"
                        ></ngx-charts-bar-vertical>
                    </div>
                </div>
            </div>

            <div class="results-area-section charts mt-2">
                <div class="chart-container pb-2">
                    <label class="info-font mt-3" for="chart">Fluxos por Nome</label>
                    <div class="chart-wrapper">
                        <ngx-charts-bar-vertical xAxisLabel="Nome"
                                                 yAxisLabel="Fluxos"
                                                 legendTitle=""
                                                 [results]="$topFlowDefinitions()"
                                                 [xAxis]="true"
                                                 [showXAxisLabel]="false"
                                                 [yAxis]="true"
                                                 [showYAxisLabel]="true"
                                                 [legend]="false"
                                                 [gradient]="true"
                                                 [showDataLabel]="true"
                        ></ngx-charts-bar-vertical>
                    </div>
                </div>
            </div>

            <div class="results-area-section charts mt-2">
                <div class="chart-container pb-2">
                    <label class="info-font mt-3" for="chart">Fluxos por Nome (sem GOVES)</label>
                    <div class="chart-wrapper">
                        <ngx-charts-bar-vertical xAxisLabel="Nome"
                                                 yAxisLabel="Fluxos"
                                                 legendTitle=""
                                                 [results]="$topFlowDefinitionsSemGoves()"
                                                 [xAxis]="true"
                                                 [showXAxisLabel]="false"
                                                 [yAxis]="true"
                                                 [showYAxisLabel]="true"
                                                 [legend]="false"
                                                 [gradient]="true"
                                                 [showDataLabel]="true"
                        ></ngx-charts-bar-vertical>
                    </div>
                </div>
            </div>
        </div>
    }
</div>
